// The Sales Order page's prompt (2026-10-26): pieces on the surplus rack that a line of this order still needs
// (jobq-api GET /surplus_rack/matches: the line's need is /truth's, the rack's free pieces of the same product).
// Re-read whenever the order is re-read (a line added or edited), so the office sees it before cutting more.
// Nothing shows when nothing matches or the read fails: a hint, never in the way.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { rackMatches } from "../features/surplus/surplusBundles";
import { surplusRackPath } from "../utils/scanCodes";

/** "7 pcs on the rack (#3, #5) could fill FAB311160: the order still needs 18". */
export function matchText(m) {
  const ids = (m.bundles || []).map((b) => `#${b.bundle_id}`).join(", ");
  return `${m.on_rack} pcs of ${m.product_id} on the surplus rack (${ids}): this order still needs ${m.still_needs}`;
}

export default function SurplusRackMatchBanner({ soId, refreshKey }) {
  const [matches, setMatches] = useState([]);
  useEffect(() => {
    let alive = true;
    setMatches([]);
    if (!soId) return undefined;
    rackMatches(soId)
      .then((d) => { if (alive) setMatches((d && d.matches) || []); })
      .catch(() => { if (alive) setMatches([]); });
    return () => { alive = false; };
  }, [soId, refreshKey]);
  if (!matches.length) return null;
  return (
    <div className="alert alert-warning py-2 mb-2" data-testid="surplus-rack-match" role="status">
      <strong>On the surplus rack:</strong>
      <ul className="mb-1 ps-3">
        {matches.map((m) => (
          <li key={m.so_line_id}>
            {matchText(m)}.{" "}
            <Link to={surplusRackPath(m.bundles[0].bundle_id)}>Allocate it from the rack</Link>
          </li>
        ))}
      </ul>
      <small className="text-muted">Use these before cutting more: allocate them on the Surplus Rack page, then move them to the pallet.</small>
    </div>
  );
}
